<template>
    <div v-if="filteredItems.length"
        ref="carousel"
        class="owl-carousel image-carousel">
        <div v-for="item in filteredItems"
            :key="item.id"
            class="item">
            <img :data-src="'https://dyn.v-office.com/image/mx/' + item.id + '.webp'"
                :alt="item.titles && item.titles.de ? item.titles.de : ''"
                class="img-fluid lazyload">
        </div>
    </div>
</template>

<script>
    import V from 'voUtils/V.js';
    export default {
    	voVueComponent: 'facility-carousel',

    	props: {
    		items: {
    			type: Array,
    			default: function() {
    				return [];
    			}
    		},

    		tags: {
    			type: Array,
    			default: function() {
    				return [];
    			}
    		}
    	},

    	computed: {
    		filteredItems: function() {
    			var tags = this.tags;

    			// Keine Tags = alle Bilder
    			if (!tags.length) {
    				return this.items;
    			}

    			return this.items.filter(function(item) {
    				return tags.indexOf(item.tag) !== -1;
    			});
    		}
    	},

    	mounted: function() {
    		this.$nextTick(this.initCarousel);
    	},

    	beforeDestroy: function() {
    		this.destroyCarousel();
    	},

    	watch: {
    		items: {
    			deep: true,
    			handler: function() {
    				this.refreshCarousel();
    			}
    		},

    		tags: {
    			deep: true,
    			handler: function() {
    				this.refreshCarousel();
    			}
    		}
    	},

    	methods: {

    		initCarousel: function() {
    			var $carousel = $(this.$refs.carousel);

    			if (!$carousel.length || !$carousel.owlCarousel) {
    				return;
    			}

    			$carousel.owlCarousel({
    				items: 1,
    				loop: true,
    				nav: false,
    				dots: true,
    				margin: 10,
    				lazyLoad: true
    			});
    		},

    		destroyCarousel: function() {
    			var $carousel = $(this.$refs.carousel);

    			if ($carousel.length && $carousel.hasClass('owl-loaded')) {
    				$carousel.trigger('destroy.owl.carousel');
    			}
    		},

    		refreshCarousel: function() {
    			var self = this;

    			this.$nextTick(function() {

    				self.destroyCarousel();

    				self.$nextTick(function() {
    					self.initCarousel();
    				});

    			});
    		}
    	}
    };
</script>